import { buildOffsetString } from './utils';
export const promql = {
    x_over_time: (x, q, range = '$__range', interval = '') => {
        return `${x}_over_time((${q})[${range}:${interval}])`;
    },
    // Aggregation over time
    avg_over_time: ({ expr, range, interval }) => promql.x_over_time('avg', expr, range, interval),
    count_over_time: ({ expr, range, interval }) => promql.x_over_time('count', expr, range, interval),
    last_over_time: ({ expr, range, interval }) => promql.x_over_time('last', expr, range, interval),
    max_over_time: ({ expr, range, interval }) => promql.x_over_time('max', expr, range, interval),
    min_over_time: ({ expr, range, interval }) => promql.x_over_time('min', expr, range, interval),
    present_over_time: ({ expr, range, interval }) => promql.x_over_time('present', expr, range, interval),
    stddev_over_time: ({ expr, range, interval }) => promql.x_over_time('stddev', expr, range, interval),
    stdvar_over_time: ({ expr, range, interval }) => promql.x_over_time('stdvar', expr, range, interval),
    sum_over_time: ({ expr, range, interval }) => promql.x_over_time('sum', expr, range, interval),
    quantile_over_time: ({ expr, range, interval }) => promql.x_over_time('quantile', expr, range, interval),
    offset: ({ units }) => buildOffsetString(units),
    by: (labels) => (labels ? ` by (${labels.join(', ')}) ` : ''),
    without: (labels) => (labels ? ` without (${labels.join(', ')}) ` : ''),
    byOrWithout: ({ by, without }) => (by ? promql.by(by) : promql.without(without)),
    // Aggregation
    sum: ({ expr, by, without }) => `sum${promql.byOrWithout({ by, without })}(${expr})`,
    min: ({ expr, by, without }) => `min${promql.byOrWithout({ by, without })}(${expr})`,
    max: ({ expr, by, without }) => `max${promql.byOrWithout({ by, without })}(${expr})`,
    avg: ({ expr, by, without }) => `avg${promql.byOrWithout({ by, without })}(${expr})`,
    group: ({ expr, by, without }) => `group${promql.byOrWithout({ by, without })}(${expr})`,
    count: ({ expr, by, without }) => `count${promql.byOrWithout({ by, without })}(${expr})`,
    stddev: ({ expr, by, without }) => `stddev${promql.byOrWithout({ by, without })}(${expr})`,
    stdvar: ({ expr, by, without }) => `stdvar${promql.byOrWithout({ by, without })}(${expr})`,
    count_values: ({ expr, by, without, parameter }) => `count_values${promql.byOrWithout({ by, without })}(${parameter}, ${expr})`,
    bottomk: ({ expr, by, without, parameter }) => `bottomk${promql.byOrWithout({ by, without })}(${parameter}, ${expr})`,
    topk: ({ expr, by, without, parameter }) => `topk${promql.byOrWithout({ by, without })}(${parameter}, ${expr})`,
    quantile: ({ expr, by, without, parameter }) => `quantile${promql.byOrWithout({ by, without })}(${parameter}, ${expr})`,
    and: ({ left, right }) => `${left} and ${right}`,
    or: ({ left, right }) => `${left} or ${right}`,
    unless: ({ left, right }) => `${left} unless ${right}`,
    rate: ({ expr, interval = '$__rate_interval' }) => `rate(${expr}[${interval}])`,
    increase: ({ expr, interval = '$__range' }) => `increase(${expr}[${interval}])`,
    // Labels
    label_replace: ({ expr, newLabel, existingLabel, replacement = '$1', regex = '(.*)' }) => `label_replace(${expr}, "${newLabel}", "${replacement}", "${existingLabel}", "${regex}")`,
    label_join: ({ expr, newLabel, separator = ',', labels }) => `label_join(${expr}, "${newLabel}", "${separator}", ${labels.map((label) => `"${label}"`).join(', ')})`,
};
